import { GRAY_100, GRAY_400, WHITE } from 'constants/styling/theme'

import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'
import { Stack } from '@mui/material'
import { useAuth0 } from 'utils/auth'
import { useTranslation } from 'react-i18next'

/**
 * @interface Props for TopBarDropdownSectionItem component
 */
export interface Props {
  /** If true, the dropdown is open */
  isOpen: boolean
  /** onClick action */
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

/**
 * @component TopBarDropdownButton to open TopBar dropdown menu
 * @example <TopBarDropdownButton />
 */
export const TopBarDropdownButton: React.FC<Props> = ({
  isOpen,
  onClick
}) => {
  const { t } = useTranslation('topbar')
  const { user } = useAuth0()

  return (
    <Stack
      onClick={onClick}
      sx={{
        height: '3.6rem',
        minWidth: '6.2rem',
        borderRadius: '4rem',
        border: `1px solid ${GRAY_400}`,
        padding: '.2rem .8rem .2rem .1rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '.4rem',
        minHeight: 'unset',
        flexDirection: 'row',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: GRAY_100
        }
      }}
    >
      <img
        src={user?.picture}
        alt={t('profile')}
        style={{ height: '3rem', width: '3rem', borderRadius: '50%', border: `1px solid ${WHITE}` }}
      />
      {isOpen ? <CloseRoundedIcon /> : <MenuRoundedIcon />}
    </Stack>
  )
}
